const onboardingMockData = {
  success: true,
  message: 'Password succesfully updated',
};

export default onboardingMockData;
